import React, { useState } from 'react';
import { Modal, Box, Typography, Divider, Button } from '@mui/material';
import { Communication } from "../../../data/Communication";
import useCommunicationTypes from "../../communicationTypes/hooks/useCommunicationTypes";
import IconList from "../../../data/account/socialMediaIcons";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    selectedCommunication: Communication | null;
}

const stripHtml = (html: string) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
};

const DetailModal: React.FC<Props> = ({ isOpen, onClose, selectedCommunication }) => {
    const [expanded, setExpanded] = useState(false);
    const { communicationTypes } = useCommunicationTypes();

    if (!selectedCommunication) return null;

    const messagePlainText = stripHtml(selectedCommunication.message || "");
    const isLongMessage = messagePlainText.length > 100;

    const selectedComType = communicationTypes.find(
        type => type.comTypeId === selectedCommunication.comTypeId
    );

    const IconComponent = selectedComType?.icon ? IconList[selectedComType.icon] : null;

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box
                sx={{
                    padding: 3,
                    backgroundColor: 'white',
                    margin: 'auto',
                    marginTop: '5%',
                    width: '80%',
                    maxWidth: '600px',
                    borderRadius: 2,
                    overflowY: 'auto'
                }}
            >
                <Typography variant="h6" gutterBottom>
                    Communication Details
                </Typography>
                <Divider sx={{ marginBottom: 2 }} />

                <Typography variant="subtitle1">
                    <strong>Title:</strong> {selectedCommunication.title}
                </Typography>

                <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <strong>Communication Type:</strong>
                    {IconComponent && <IconComponent />}
                    {selectedComType?.comType || ""}
                </Typography>

                <Typography variant="subtitle1">
                    <strong>Event:</strong> {selectedCommunication.eventName}
                </Typography>
                <Typography variant="subtitle1">
                    <strong>Status:</strong> {selectedCommunication.status}
                </Typography>
                <Typography variant="subtitle1">
                    <strong>Composed By:</strong> {selectedCommunication.composedBy}
                </Typography>
                <Typography variant="subtitle1">
                    <strong>Reviewed By:</strong> {selectedCommunication.reviewedBy}
                </Typography>
                <Typography variant="subtitle1">
                    <strong>Reviewed Time Stamp:</strong> {selectedCommunication.reviewedTimeStamp}
                </Typography>

                {/* Message (Plain Text) */}
                <Typography variant="subtitle1" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    <strong>Message:</strong> {expanded ? messagePlainText : `${messagePlainText.substring(0, 100)}...`}
                </Typography>

                {isLongMessage && (
                    <Button
                        onClick={() => setExpanded(!expanded)}
                        size="small"
                        sx={{ marginTop: 1, textTransform: 'none' }}
                    >
                        {expanded ? "Show Less" : "Read More"}
                    </Button>
                )}
            </Box>
        </Modal>
    );
};

export default DetailModal;
